import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../index';
import { ICreateMessageForOfferRequest } from '../../repositories/demand/v2/create-message-for-offer';
import { demandLastRequestedData } from '@cian/demand-trap-widget';
import { sendDemandRequest } from '../demand/demandThunk';
import { selectLastDemandRequest } from '../../selectors/requestDemand';
import { trackSmsAgain } from '../../components/demand/utils/tracking';

export const verifyPhoneRetry = (isNewDemandRequest?: boolean): ThunkAction<void, IState, IContext> => {
  return (dispatch, getState) => {
    const state = getState();
    const demandData: ICreateMessageForOfferRequest = isNewDemandRequest
      ? selectLastDemandRequest(state)
      : demandLastRequestedData(state);

    trackSmsAgain(Boolean(demandData.isHomeowner));
    delete demandData.confirmationCode;

    dispatch(sendDemandRequest({ ...demandData, source: 'Card' }));
  };
};
